import React from 'react';
import { notification, Switch } from 'antd';
import { useEffect, useState } from 'react';
import { SR, SRE } from '../../api/pushGenie';
import { pushGenieToBE } from '../../store/appReduxMiddleware';
import { getItemFromMisc, MISC_KEYS, updateItemInMisc } from '../../store/idbHandler';
import { OLD_RESTRICTIONS } from '../../restrictions/oldStaffRestrictions';
import { track } from '../../tracking';
import { getMyDbId } from '../../api/mactiveid';
import { initAccessControl } from '../../store/AccessControl';
import { v4 } from 'uuid';

const StaffRescription: React.FC = () => {
    const [configArray, setConfigArray] = useState<Set<SR>>(new Set<SR>());
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        getItemFromMisc<SR[]>(getMyDbId() || '', MISC_KEYS.staffRestriction).then((data) => {
            if (data) {
                setConfigArray(new Set(data));
            }
        });
    }, []);

    const onToggleClick = (key: SRE) => {
        if (configArray.has(SRE[key])) {
            configArray.delete(SRE[key]);
        } else {
            configArray.add(SRE[key]);
        }
        setConfigArray(new Set(configArray));
    };

    const onSave = async () => {
        setIsLoading(true);
        await updateItemInMisc<SR[]>(
            getMyDbId() || '',
            MISC_KEYS.staffRestriction,
            Array.from(configArray),
        );
        await pushGenieToBE(getMyDbId() || '', ['staffRestriction']);
        const trackingId = v4();
        await Promise.all([initAccessControl(trackingId)]);
        setIsLoading(false);
        notification.success({
            message: 'Successfully Saved',
            duration: 5,
        });
        track('STAFF_RESTRICTION_SAVE');
    };

    return (
        <div className="w-full flex flex-col h-full space-between">
            <p className="text-16 font-700 text-neutral-black py-16 px-24">Staff Restrictions</p>

            <div className="relative flex flex-col items-center justify-center flex-1 space-y-16 h-full overflow-auto">
                <div className="px-24 h-full w-full bg-white space-y-8 overflow-auto">
                    <div className="flex mt-16 flex-col mb-150 w-full space-y-32 items-start justify-center">
                        {OLD_RESTRICTIONS.filter((data) => !data.isHidden).map((data) => {
                            return (
                                <div className="flex  w-full lg:w-632 items-start justify-between">
                                    <div className="mr-32">
                                        <p className="font-700 text-neutral-1">{data.title}</p>
                                        {/* <span className="text-14">{data[1].summary}</span> */}
                                    </div>

                                    <Switch
                                        className="link-color"
                                        checked={!configArray.has(SRE[data.key])}
                                        onChange={() => onToggleClick(data.key)}
                                    />
                                </div>
                            );
                        })}
                    </div>
                </div>
                <div className="relative bottom-24 w-full px-16 bg-white">
                    <div className="flex items-center justify-end rounded-8 bg-actionPrimary bottom-24 inset-x-10 px-16 py-8 cta-row">
                        <button
                            onClick={onSave}
                            disabled={isLoading}
                            className="px-16 py-8 btn--small primary-btn-v2 tooltip-wrapper"
                        >
                            {isLoading && (
                                <div className="w-20 h-20">
                                    <svg className="circular-loader" viewBox="25 25 50 50">
                                        <circle
                                            className="loader-path"
                                            cx="50"
                                            cy="50"
                                            r="20"
                                            fill="none"
                                            stroke="#000000"
                                            stroke-width="3"
                                        ></circle>
                                    </svg>
                                </div>
                            )}
                            <p>Save Changes</p>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default StaffRescription;
